import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: (fullWidth?: boolean) => Interpolation<Theme> = (fullWidth) =>
  css`
    width: ${fullWidth ? '100%' : '263px'};
  `

export const labelWrapper: Interpolation<Theme> = (theme) => css`
  width: 100%;
  margin: 0;
  align-items: initial;
  gap: 10px;

  & > .MuiTypography-root {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.typographyColors.typographyThree};
  }
`

export const searchIcon: Interpolation<Theme> = (theme) => css`
  min-width: 22px;
  color: ${theme.typographyColors.typographyThree};
`
